import React from 'react';
import withTracking from 'tracking/withTracking';
import PropTypes from 'prop-types';

const Track = ({ innerAs, analytics, trackingParams, onClick, ...props }) => {
    const onClickTracking = (...args) => {
        analytics.trackEvent(trackingParams);

        if (onClick) {
            onClick(...args);
        }
    };

    const WrappedComponent = innerAs;

    return <WrappedComponent onClick={onClickTracking} {...props} />;
};

Track.defaultProps = {
    innerAs: 'div',
};

Track.propTypes = {
    trackingParams: PropTypes.shape({
        type: PropTypes.string.isRequired,
        context: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        position: PropTypes.string.isRequired,
        label: PropTypes.string,
    }).isRequired,
    innerAs: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType])
        .isRequired,
};

export default withTracking(Track);
